import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import ProviderAccount, { MappedProviderAccount } from '~/types/ProviderAccount';
import ServiceLevel, { MappedServiceLevelsToken } from '~/types/ServiceLevel';
import { getFailed, getNotRequested, getRequesting, getSuccess } from '~/utils/fetchable';

export type ProvidersState = {
  readonly serviceLevelsByAccountRequest: Requestable<ProviderAccount[], string>;
  readonly mappedServiceLevelsByToken: MappedServiceLevelsToken;
  readonly mappedServiceLevelsByAccount: MappedProviderAccount;
};

const initialState: ProvidersState = {
  serviceLevelsByAccountRequest: getNotRequested(),
  mappedServiceLevelsByToken: {},
  mappedServiceLevelsByAccount: {},
};

function reducer(state: ProvidersState = initialState, action: ActionTypes): ProvidersState {
  switch (action.type) {
    case ActionKeys.FETCH_SERVICE_LEVELS_BY_ACCOUNT:
      return {
        ...state,
        serviceLevelsByAccountRequest: getRequesting(),
      };
    case ActionKeys.FETCH_SERVICE_LEVELS_BY_ACCOUNT_SUCCESS:
      const serviceLevelsByAccount = getSuccess(action.payload.providerAccounts);
      let mappedAccounts: Record<string, ProviderAccount[]> = {};
      let mappedServiceLevelsByToken: Record<string, ServiceLevel[]> = {};

      for (const account of serviceLevelsByAccount.data) {
        // create mappedAccounts Object
        if (!mappedAccounts[account.providerToken]) {
          mappedAccounts[account.providerToken] = [account];
        } else {
          mappedAccounts[account.providerToken].push(account);
        }

        // create mappedServiceLevelsByToken
        for (const serviceLevel of account.serviceLevels) {
          const account_object_id = account.objectId;
          let serviceLevelWithObjectId = { ...serviceLevel, account_object_id };

          // set the account_object_id on the parent, if the parent exists
          if (serviceLevelWithObjectId.parent_servicelevel && account_object_id) {
            serviceLevelWithObjectId.parent_servicelevel.account_object_id = account_object_id;
          }
          if (mappedServiceLevelsByToken[serviceLevel.token]) {
            mappedServiceLevelsByToken[serviceLevel.token].push(serviceLevelWithObjectId);
          } else {
            mappedServiceLevelsByToken[serviceLevel.token] = [serviceLevelWithObjectId];
          }
        }
      }

      return {
        ...state,
        serviceLevelsByAccountRequest: serviceLevelsByAccount,
        mappedServiceLevelsByToken: mappedServiceLevelsByToken,
        mappedServiceLevelsByAccount: mappedAccounts,
      };
    case ActionKeys.FETCH_SERVICE_LEVELS_BY_ACCOUNT_ERROR:
      return {
        ...state,
        serviceLevelsByAccountRequest: getFailed(action.payload.errorMessage),
      };
    default:
      return state;
  }
}

export default reducer;
